import { styled } from 'styled-components';

export const Backdrop = styled.span`
    position: absolute;
    background-image: linear-gradient(310deg, var(--bs-gradient-dark-right), var(--bs-gradient-dark-left));
    background-position: 50%;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    opacity: 0.65;
    z-index: -1;
`
